import { User } from '../types/User';
import { apiPost } from './apiClient';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface AuthData {
  accessToken: string;
  user: User;
}

export interface LoginResponse {
  isSucceed: boolean;
  data: AuthData;
}

export interface GoogleLoginRequest {
  credential: string;
}

export interface RegisterRequest {
  username: string;
  email: string;
  password: string;
  favouriteTeams: unknown[];
}

// The API returns a result wrapper (HTTP 200 even on validation failures), so
// the body must be inspected to know whether registration actually succeeded.
export interface RegisterResponse {
  isSucceed: boolean;
  messages?: Record<string, string[]>;
  data: boolean;
}

// Backend key returned when the username/email already belongs to another user.
const DUPLICATE_USER_KEY = 'sameUserNameOrEmail';

export function isDuplicateUserError(response: RegisterResponse): boolean {
  return Boolean(response.messages && DUPLICATE_USER_KEY in response.messages);
}

// Flattens the API's { field: string[] } message bag into a single readable
// string, falling back to a generic message when none is provided.
export function getRegisterErrorMessage(response: RegisterResponse): string {
  const messages = response.messages
    ? Object.values(response.messages).flat()
    : [];
  return messages.length > 0
    ? messages.join('\n')
    : "User couldn't be created - try once more.";
}

export function login(body: LoginRequest): Promise<LoginResponse> {
  return apiPost<LoginResponse>('/api/Authorization/Login', body, false);
}

export function googleLogin(body: GoogleLoginRequest): Promise<{ data: AuthData }> {
  return apiPost<{ data: AuthData }>('/api/Authorization/GoogleLogin', body, false);
}

export function register(body: RegisterRequest): Promise<RegisterResponse> {
  return apiPost<RegisterResponse>('/api/Authorization/Register', body, false);
}
